import type { ArgusSessionDetailResponse, ArgusSessionResponse } from "../../types/argus";
import { useApiQuery } from "../use-api-query";

export function useArgusSession(sessionId: string | undefined) {
  const query = useApiQuery<ArgusSessionDetailResponse>(`/client/argus/sessions/${sessionId}`, {
    enabled: !!sessionId,
  });

  return {
    ...query,
    session: query.data?.data as ArgusSessionResponse | undefined,
  };
}
